import { render, staticRenderFns } from "./ECardIndicador.vue?vue&type=template&id=857975f2&scoped=true"
import script from "./ECardIndicador.vue?vue&type=script&lang=js"
export * from "./ECardIndicador.vue?vue&type=script&lang=js"
import style0 from "./ECardIndicador.vue?vue&type=style&index=0&id=857975f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857975f2",
  null
  
)

export default component.exports